"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrentPagePattern = getCurrentPagePattern;
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _get = _interopRequireDefault(require("lodash/get"));

var _store = _interopRequireDefault(require("../../store"));

var _runtimeConfigHelper = require("../../helpers/runtime-config-helper");

function shellRunsInWordpress() {
  var _window$wp;

  return !!((_window$wp = window.wp) === null || _window$wp === void 0 ? void 0 : _window$wp.data);
}

function getPathName() {
  var pathname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.pathname;
  var hash = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.hash;

  if (shellRunsInWordpress()) {
    var hashUrl = hash;

    if (hashUrl.indexOf('#') !== -1) {
      hashUrl = hashUrl.replace('#', '');
    }

    if (hashUrl.indexOf('?') !== -1) {
      hashUrl = hashUrl.split('?')[0];
    }

    return hashUrl;
  }

  return pathname;
} // '/test/123/2261fe6f-509a-4f51-81b7-0128372c19d6/tes2t' => "/test/number/guid/tes2t"


function cleanPathName(path) {
  return path.split('/').filter(function (x) {
    return !!x;
  }).map(function (segment) {
    if (Number.isInteger(Number(segment))) {
      return 'number';
    }

    if (/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(segment)) {
      return 'guid';
    }

    if (/^[0-9a-fA-F]{32}$/.test(segment)) {
      return 'guid';
    }

    return segment;
  }).join('/');
}

function getCurrentPagePattern() {
  return cleanPathName(getPathName());
}

function getRouteObj() {
  var state = (0, _store["default"])().getState();
  var pageId = (0, _get["default"])(state, 'router.activePage.pattern'); // const pagePattern = get(state, 'router.activePage.path')

  var pageType = (0, _get["default"])(state, 'router.activePage.pageType') || '';
  var activePath = (0, _get["default"])(state, 'router.activePath');
  var flowType = (0, _get["default"])(state, 'router.activePage.flowType') || '';
  var path = getPathName();
  var route = cleanPathName(path);
  var routeObj = {
    pageId: pageId,
    pagePattern: route,
    pageType: pageType,
    activePath: activePath,
    flowType: flowType,
    appName: (0, _runtimeConfigHelper.getRuntimeConfig)()._app
  };
  return routeObj;
}
/**
 * Google Tag Manager Logger, includes javascript from tag manager, and starts logging when its loaded
 * these methodes will be called by the analytics service!
 *
 * @class GoogleTagManagerLogger
 */


var GoogleTagManagerLogger = /*#__PURE__*/function () {
  function GoogleTagManagerLogger() {
    (0, _classCallCheck2["default"])(this, GoogleTagManagerLogger);
  }

  (0, _createClass2["default"])(GoogleTagManagerLogger, [{
    key: "login",
    value:
    /**
     * Triggered by Analytics Service - Do not call this methodes out side the analytics service
     *
     *
     * @memberOf GoogleTagManagerLogger
     */
    function login(name, email, accountId, globalIdentity) {
      var _window$builderShell$;

      var routeObj = getRouteObj();
      (_window$builderShell$ = window.builderShell.analyticsApi) === null || _window$builderShell$ === void 0 ? void 0 : _window$builderShell$.login(name, email, accountId, globalIdentity, routeObj);
    }
    /**
     * Triggered by Analytics Service - Do not call this methodes out side the analytics service
     *
     *
     * @memberOf GoogleTagManagerLogger
     */

  }, {
    key: "logout",
    value: function logout() {}
    /**
     * Triggered by Analytics Service - Do not call this methodes out side the analytics service
     *
     *
     * @memberOf GoogleTagManagerLogger
     */

  }, {
    key: "trackPageView",
    value: function trackPageView(path) {
      var _window$builderShell$2;

      var routeObj = getRouteObj();
      (_window$builderShell$2 = window.builderShell.analyticsApi) === null || _window$builderShell$2 === void 0 ? void 0 : _window$builderShell$2.trackPageView(path, routeObj);
    }
    /**
     * Triggered by Analytics Service - Do not call this methodes out side the analytics service
     *
     *
     * @memberOf GoogleTagManagerLogger
     */

  }, {
    key: "trackUserDomains",
    value: function trackUserDomains(domainCountObject) {
      var _window$builderShell$3;

      var routeObj = getRouteObj();
      (_window$builderShell$3 = window.builderShell.analyticsApi) === null || _window$builderShell$3 === void 0 ? void 0 : _window$builderShell$3.trackUserDomains(domainCountObject, routeObj);
    }
    /**
     * Triggered by Analytics Service - Do not call this methodes out side the analytics service
     *
     *
     * @memberOf GoogleTagManagerLogger
     */

  }, {
    key: "trackEvent",
    value: function trackEvent(action, obj) {
      var _window$builderShell$4;

      var routeObj = getRouteObj();
      (_window$builderShell$4 = window.builderShell.analyticsApi) === null || _window$builderShell$4 === void 0 ? void 0 : _window$builderShell$4.trackEvent(action, obj, routeObj);
    }
    /**
     * Triggered by Analytics Service - Do not call this methodes out side the analytics service
     *
     *
     * @memberOf GoogleTagManagerLogger
     */

  }, {
    key: "trackEcommercePurchase",
    value: function trackEcommercePurchase(orderId, totalPriceExTax, totalTax, status, products) {
      var _window$builderShell$5;

      var routeObj = getRouteObj();
      (_window$builderShell$5 = window.builderShell.analyticsApi) === null || _window$builderShell$5 === void 0 ? void 0 : _window$builderShell$5.trackEcommercePurchase(orderId, totalPriceExTax, totalTax, status, products, routeObj);
    }
  }]);
  return GoogleTagManagerLogger;
}();

var _default = new GoogleTagManagerLogger();

exports["default"] = _default;